import React, { useState } from 'react'
import * as ROUTE from 'common/constant/routes'
import PLLogo from 'img/PL_PLCP_logo.png'
import classnames from 'classnames'
import { Row, Button, Col } from 'react-bootstrap'
import LoginForm from './component/form'
import styles from './styles'

const API_URL = process.env.API_URL

const Login = () => (
  <Row className={classnames(styles.login_bg, styles.full_height)}>
    <Col
      className='vh-100'
      lg={6}
      md={12}
    >
      <Hero />
      <Footer />
    </Col>
    <Col
      lg={6}
      md={12}
    />
  </Row>
)

const Hero = () => {
  const [generalLogin, setGeneralLogin] = useState(false)

  const toggle = () => setGeneralLogin(!generalLogin)

  return (<>
    <Row className='h-75'>
      <Col
        className='h-100 d-flex flex-column align-items-center justify-content-evenly'
        lg={12}
      >
        <img
          alt='Premier League Logo'
          className={styles.logo}
          src={PLLogo}
        />
        <div className='w-50 d-flex justify-content-evenly'>
          <h1 className={classnames(styles.plcp_text, 'text-white')}>Premier League Football Site</h1>
        </div>
        <div className={styles.login_form_container}>
          {generalLogin
                ? <LoginForm toggle={toggle} />
                : <div className={styles.login_buttons}>
                  <Row>
                    <Button
                      className={classnames(styles.pl_login_button, styles.login_buttons_shared)}
                      href={API_URL + ROUTE.TCP_LOGIN}
                    >Premier League Login</Button>
                  </Row>
                  <Row>
                    <Button
                      className={classnames(styles.external_login_button, styles.login_buttons_shared)}
                      onClick={toggle}
                    >General Login</Button>
                  </Row>
                </div>
          }

        </div>
      </Col>
    </Row>

  </>
  )
}

const date = new Date()
const Footer = () => (
  <Row className='h-25'>
    <Col className='h-100 d-flex flex-column align-items-center justify-content-evenly'>
      {<div>
        <p>Do not hesitate to contact us</p>
        <p>
          <a
            className='text-pink'
            href='mailto:support@pl.com?subject=Example%20support%20ticket'
          >support@pl.com</a></p>
      </div>}
      <small>&copy; Premier League {date.getFullYear()}</small>
    </Col>
  </Row>
)

export default Login
